<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Receivers') },
                { title: $t('ReceiverCC') },
                { title: $t('NotificationTitle') },
                { title: $t('NotificationText') },
                { title: $t('SendStatus') }
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 25%">
                  <span v-if="row.receivers.length > 1">
                    <vs-button
                      color="success"
                      type="gradient"
                      icon-pack="feather"
                      class="d-inline"
                      @click="isReceiversAndReceiverCCList(row, 1)"
                    >
                      {{ $t("ReceiversList") }}</vs-button
                    >
                  </span>
                  <span v-else>
                    <span v-if="row.receivers[0]">{{ row.receivers[0] }}</span>
                    <span v-else>----</span>
                  </span>
                </td>
                <td style="width: 25%">
                  <span v-if="row.ccReceivers.length > 1">
                    <vs-button
                      color="success"
                      type="gradient"
                      icon-pack="feather"
                      class="d-inline"
                      @click="isReceiversAndReceiverCCList(row, 2)"
                    >
                      {{ $t("ReceiverCCList") }}</vs-button
                    >
                  </span>
                  <span v-else>
                    <span v-if="row.ccReceivers[0]">{{
                      row.ccReceivers[0]
                    }}</span>
                    <span v-else>----</span>
                  </span>
                </td>
                <td style="width: 15%">
                  <span v-if="row.subject">{{ row.subject }}</span>
                  <span v-else class="text-danger inline">{{
                    $t("Untitled")
                  }}</span>
                </td>
                <td style="width: 15%">
                  <span v-if="row.text"
                    ><vs-button
                      color="success"
                      type="gradient"
                      class="mx-4 d-inline"
                      @click="isDetailsNotification(row)"
                      >{{ $t("NotificationText") }}
                    </vs-button></span
                  >
                </td>
                <td style="width: 15%">
                  {{ row.isSent ? "ارسال شده" : "ارسال نشده" }}
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
      <details-notification-popup
        :show="showDetailsNotificationPopup"
        :DetailsNotification="DetailsNotification"
        @finish="onfinish"
      ></details-notification-popup>
      <receiverCC-and-receiver-popup
        :show="showReceiversAndReceiverCCListPopup"
        :receiversOrReceiverCCList="receiversOrReceiverCCList"
        :type="type"
        @finish="onfinish"
      ></receiverCC-and-receiver-popup>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import DetailsNotificationPopup from "./DetailsNotificationPopup.vue";
import ReceiverCCAndReceiverPopup from "./ReceiverCCAndReceiverPopup.vue";

export default {
  name: "",
  components: {
    DataGrid,
    DetailsNotificationPopup,
    ReceiverCCAndReceiverPopup
  },
  data() {
    return {
      gridDataSource: {
        type: "app",
        service: "Notifications/api/Immediate"
      },
      gridSearchData: {},
      showDetailsNotificationPopup: false,
      showReceiversAndReceiverCCListPopup: false,
      receiversOrReceiverCCList: [],
      DetailsNotification: {},
      type: 0
    };
  },
  methods: {
    isDetailsNotification(text) {
      this.showDetailsNotificationPopup = true;
      this.DetailsNotification = text;
    },
    isReceiversAndReceiverCCList(text, type) {
      this.showReceiversAndReceiverCCListPopup = true;
      this.type = type;
      if (type == 1) {
        this.receiversOrReceiverCCList = text.receivers;
      } else {
        this.receiversOrReceiverCCList = text.ccReceivers;
      }
    },
    onfinish() {
      this.showDetailsNotificationPopup = false;
      this.showReceiversAndReceiverCCListPopup = false;
      this.$refs.grid.renderGrid();
    }
  }
};
</script>
